import React from "react";
import "../Styles/privacyPolicy.css";

export default function Policy() {
  return (
    <>
      <div style={{ height: "108px" }}></div>

      <div className="Privacy">
        <div className="text">
          <h2>PRIVACY POLICY</h2>

          <div className="privacy">
            <p>
              We value and respect your privacy. The following document clearly
              states how we manage, store, and use your data. Please read it
              carefully so that you are well aware of what happens to your
              information once you fill any form on our website or agree to any
              service. Any changes made to the privacy policy will be reflected
              here. Hence, we request you to check back in periodically.
            </p>
            <h5>Where we get your data from:</h5>
            <ol>
              <li>The information you give us:</li>
              <ol type="a">
                <li>When placing an order.</li>
                <li>On creating an account/ profile</li>
                <li>While compiling wish lists.</li>
                <li>
                  When you communicate with us through email, telephone, or
                  otherwise.
                </li>
                <li>
                  When you sign up to be alerted about the availability of any
                  products.
                </li>

                <p>
                  This information can include your name, email id, phone
                  number, address, as well as those of the people you are
                  sending the products to for any reason; your photograph;
                  financial information (credit/ debit cards).
                </p>
              </ol>
              <li>Information automatically collected:</li>
              <ol type="a">
                <li>Computer’s Internet protocol (IP) address.</li>
                <li>
                  Information related to your computer and its connection such
                  as browser type, version, time zone setting, browser plug-in
                  types and versions, operating system, and platform.
                </li>
                <li>Purchase history.</li>
                <li>Products you viewed or searched for.</li>
                <li>Cookie number.</li>
                <li>
                  How long you stayed on the website and what features you used.
                </li>
              </ol>
              <li>When do we share the data and with whom?</li>
              <ol type="a">
                <li>Third party delivery services</li>
                <li>
                  Your name, address, and telephone number is shared with a
                  promise on the part of the delivery company to not share or
                  use the information in any way.
                </li>
                <li>Third party payment providers.</li>
                <li>
                  Your name, address, debit. Credit card information, order
                  information is shared.
                </li>
                <li>Transfer of business.</li>
                <li>
                  In case TSB merges or is bought by another company, customer
                  information is one of the assets shared or given away, subject
                  to the pre-existing Privacy Policy.
                </li>
                <li>In a legal context.</li>
                <li>
                  To respond to a lawful request, search warrant, or subpoena.
                  It may also be shared when we believe it is instrumental in
                  protecting the rights, property, and safety of TSB as well as
                  its customers. No information is ever disclosed, sold, shared,
                  or rented for commercial purposes.
                </li>
              </ol>
              <li>Your rights:</li>
              <ol type="a">
                <li>
                  Right to request access to data that we store about you.
                </li>
                <li>
                  Right to demand changes in incorrect or inaccurate data.
                </li>
                <li>
                  Right to demand the termination of processing of your data any
                  longer.
                </li>
                <li>Right to lodge a complaint should you wish.</li>
              </ol>
              <h5>Cookies:</h5>
              <p>
                A cookie is a small text file that enables various features of
                TSB and is placed on your computer or mobile. They store user
                preferences and track user trends in order to better your
                experience on the website and provide customized options to you.
                You can decide whether you want cookies to be enabled for your
                Internet surfing or not using the browser settings. Leaving them
                on will mean that you accept to our usage of whatever personal
                information is collected by our cookie.
              </p>
              <h5>Do not track</h5>
              <p>
                Please note that we do not alter our Site’s data collection and
                use practices when we see a ‘Do Not Track’ signal from your
                browser.
              </p>
              <h5>Contact us</h5>
              <p>
                For more information about our privacy practices, if you have
                questions, or if you would like to make a complaint, please
                contact us by e-mail at{" "}
                <a href="mailto:empirefootwear@gmail.com">
                  {" "}
                  empirefootwear@gmail.com
                </a>{" "}
                .
              </p>
            </ol>
          </div>
        </div>
      </div>
    </>
  );
}
